import { Grid } from '@mui/material';
import './keep.styles.scss';
import Button from '../../../components/button/button.component';
import { useContext, useEffect } from 'react';
import { CancelContext } from '../../../contexts/cancellation.context';
import shopImg from '../../../imgs/shop_logo2.png';
import { freshDeskReport, setCookie } from '../../../utils/generaFunctions';

const Keep = () => {
    const {userInfo, cancelInfo, changeCancelInfo, setLoading} = useContext(CancelContext);
    useEffect(()=>{
        setCookie("cancellation-"+userInfo.email,"yes", 1/12);
        if(cancelInfo.reactivated){
            changeCancelInfo({reactivated: false});
            setLoading(false);
        } else {
            freshDeskReport(userInfo.email, userInfo.name, "Keep Subscription during Cancellation flow", "Sys2.0: Prevented", "Sys2.0: Prevented", "Sys2.0: Keep Subscription").then(()=>{
                setLoading(false);
            })
        }
    },[]);
    return (
        <Grid container className='confirmed-container'>
            <Grid container className='flex-vertical'>
                <Grid item className='title'>
                    <h1>We’re glad you stayed</h1>
                </Grid>
                <Grid item className='body-roman' >
                    We want to sincerely thank you for being part of the Miss To Mrs community. This is an incredibly special (and sometimes stressful!) time in your life, and we’re grateful to be a part of it and bring you some joy.
                </Grid>
                <div className='line'></div>
                <Grid item className='body-roman' >
                    Don't miss out on our SHOP's amazing à la carte selection. #TreatYourself
                    <img className='shop_image' alt={`img-shop`} src={shopImg} style={{display:shopImg?"":"none"}}></img>
                </Grid>
                <a className={`button-link`} href={"https://shop.misstomrsbox.com/"}><Button text="Shop Now"></Button></a>
            </Grid>
        </Grid>
    )
}

export default Keep;